import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSampleMeta } from '../hooks/useSampleMeta';
import { LoadingDisplay } from '../components/LoadingDisplay.tsx';
import { ErrorDisplay } from '../components/ErrorDisplay.tsx';
import { getSampleViewUrl } from '../utils/url.ts';

export default function SamplePermalink() {
  const { uuid } = useParams<{ uuid: string }>();
  const { sampleMeta, isLoading, error } = useSampleMeta(uuid);

  const redirectUrl = useMemo(() => {
    if (!sampleMeta) return null;
    const { eval_set_id, filename, id, epoch } = sampleMeta;
    return getSampleViewUrl({
      evalSetId: eval_set_id,
      filename,
      sampleId: id,
      epoch,
    });
  }, [sampleMeta]);

  useEffect(() => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  }, [redirectUrl]);

  if (isLoading) {
    return <LoadingDisplay message="Loading sample..." subtitle={uuid} />;
  }

  if (error) {
    return <ErrorDisplay message={error.message} />;
  }

  if (redirectUrl) {
    return (
      <LoadingDisplay message="Redirecting to sample..." subtitle={uuid} />
    );
  }

  return null;
}
